import { render, staticRenderFns } from "./PrimetrustExchangeInput.vue?vue&type=template&id=7f0baae2&"
import script from "./PrimetrustExchangeInput.vue?vue&type=script&lang=ts&"
export * from "./PrimetrustExchangeInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports